import React from 'react'
import { FieldError, NestDataObject } from 'react-hook-form'
import { IOption } from '../../interfaces/FormFields'
import { AUTRE } from '../../enums/common'
import {
  FRANCE,
  MONACO,
  ST_BARTHELEMY,
  ST_MARTIN,
  ST_PIERRE_AND_MIQUELON,
} from '../../enums/Countries'

export const USA_COUNTRY_CODE = 'USA'

export const FrenchColonies: IOption[] = [
  { value: FRANCE, label: 'France ( sauf les cas particuliers )' },
]

export const Monaco: IOption[] = [{ value: MONACO, label: 'Monaco' }]

export const ResidesFrenchColonies: IOption[] = [
  {
    value: ST_MARTIN,
    label: 'Je réside à St Martin de manière continue depuis plus de 5 ans',
  },
  {
    value: ST_BARTHELEMY,
    label: 'Je réside à St Barthelemy de manière continue depuis plus de 5 ans',
  },
  {
    value: ST_PIERRE_AND_MIQUELON,
    label:
      'Je réside à St Pierre et Miquelon de manière continue depuis plus de 5 ans',
  },
  {
    value: 'WLF',
    label: 'Je réside à Wallis et Futuna plus de la moitié de l’année',
  },
  {
    value: 'PYF',
    label: 'Je réside en Polynésie Française plus de la moitié de l’année',
  },
  {
    value: 'NCL',
    label: 'Je réside en Nouvelle Calédonie plus de la moitié de l’année',
  },
  {
    value: 'ATF',
    label:
      'Je réside en Terres Australes Française plus de la moitié de l’année',
  },
]

export const ResidenceFiscale: IOption[] = [
  { value: '', label: 'Sélectionner' },
  ...FrenchColonies,
  ...Monaco,
  { value: AUTRE, label: 'Autre pays' },
]

export const autreDifferentTaxCountryRaison = '6'
export const differentTaxCountryRaison: IOption[] = [
  { value: '', label: 'Sélectionner' },
  { value: '1', label: 'Je suis étudiant ou enseignant étranger en France' },
  {
    value: '2',
    label: 'Je suis étudiant ou enseignant français hors de France',
  },
  {
    value: '3',
    label:
      'Je suis membre du personnel d’une ambassade ou d’un consulat au service du pays indiqué comme étant celui de ma résidence fiscale',
  },
  {
    value: '4',
    label:
      'Je suis expatrié mais j’ai conservé mon statut de résident fiscal de mon pays d’origine',
  },
  {
    value: '5',
    label: 'Je réside aux Etats-Unis, mais ce n’est pas ma résidence fiscale',
  },
  { value: autreDifferentTaxCountryRaison, label: 'Autre raison' },
]

export const situationMonegasque: IOption[] = [
  { value: '', label: 'Sélectionner' },
  {
    value: '1',
    label:
      'Je suis de nationalité monégasque ou étrangère (hors nationalité française)',
  },
  {
    value: '2',
    label:
      'Je suis de nationalité française mais j’y réside de manière continue depuis le 13/10/1957 ou depuis ma naissance',
  },
]

export const autreMissingNifReason = '3'
export const missingNifReason: IOption[] = [
  { value: '', label: 'Sélectionner' },
  {
    value: '1',
    label:
      'Mon pays de résidence fiscale n’émet pas de NIF ou d’équivalent fonctionnel',
  },
  {
    value: '2',
    label:
      'Mon pays de résidence fiscale ne m’a pas attribué de NIF ou d’équivalent fonctionnel',
  },
  { value: autreMissingNifReason, label: 'Autre raison' },
]

export const RadioButtonOptions: IOption[] = [
  { value: '0', label: 'Non' },
  { value: '1', label: 'Oui' },
]

export const customStyles = (
  errors: NestDataObject<Record<string, any>, FieldError>,
  taxCountryOtherSuffix: string
) => ({
  control: (styles: React.CSSProperties) => ({
    ...styles,
    height: '5.2rem',
    cursor: 'pointer',
    borderRadius: 'none',
    border: errors[taxCountryOtherSuffix]
      ? `1px solid #ff0000`
      : '1px solid #d8d8d8',
    boxShadow: 'none',
    '&:hover': {
      border: errors[taxCountryOtherSuffix]
        ? '1px solid #ff0000'
        : '1px solid #d8d8d8',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (styles: React.CSSProperties) => ({
    ...styles,
    color: '#17479e',
  }),
  menu: (styles: React.CSSProperties) => ({
    ...styles,
    margin: '0',
    padding: '0',
    border: '1px solid #d8d8d8',
    boxShadow: 'none',
    borderRadius: 'none',
  }),
  menuList: (styles: React.CSSProperties) => ({
    ...styles,
    margin: '0',
    padding: '0',
  }),
  option: (styles: React.CSSProperties, { isSelected }: any) => ({
    ...styles,
    height: '5.2rem',
    borderBottom: '1px solid #d8d8d8',
    backgroundColor: isSelected ? '#f3f6fa' : '#fff',
    color: isSelected && '#212529',
    paddingTop: '18px',
    '&:hover': {
      backgroundColor: '#f8f9fa',
      cursor: 'pointer',
    },
  }),
})
